<template>
  <div class="message-confirmation">

    <div class="row row-tabs mt-4">
      <div class="col-12 confirmation-title">
        <h1 class="text-center">Bestätigungen</h1>
        <button @click="$router.go(-1)" class="go-back btn-cursor" type="button" name="button">
          <img class="ml-4" :src="'./static/img/' + user.role +'/close.png'" alt="">
        </button>
      </div>
      <div class="col-12">
        <b-tabs>
          <b-tab title="bestätigt" active>

            <div v-for="message_confirmed in messagesConfirmed" v-if="message_confirmed.confirmedBy !== ''" class="single-confirmation confirmed" style="border-bottom: 1px solid #ddd;">
              <p>{{ message_confirmed.sender.title }}</p>
              <span>Bestätigt von: {{ message_confirmed.confirmed_by.title }}, am {{ message_confirmed.date | formatDate }}</span>
              <button class="btn-cursor" v-if="message_confirmed.has_message==true" @click="showModal(message_confirmed)" type="button" name="button">
                <img v-if="message_confirmed.unread" width="32" height="32" class="icon-message" :src="'./static/img/' + user.role +'/message_text.png'" alt="">
                <img v-else width="32" height="32" class="icon-message" :src="'./static/img/' + user.role +'/message_text_readed.png'" alt="">
              </button>
            </div>
            <div v-if="messagesConfirmed.length === 0" class="empty-list text-center mt-2">
              {{ emptyConfirmedListAlert }}
            </div>

          </b-tab>
          <b-tab title="unbestätigt" >

            <div v-for="message_unconfirmed in messagesUnconfirmed" class="single-confirmation unconfirmed" style="border-bottom: 1px solid #ddd;">
              <p>{{ message_unconfirmed.title }}</p>
            </div>
            <div v-if="messagesUnconfirmed.length === 0" class="empty-list text-center mt-2">
              {{ emptyUnconfirmedListAlert }}
            </div>

            <h5 v-if="messagesUnconfirmed.length !== 0 && message.date_reminder" class="message-uptitle mt-3">
              Erinnerung gesendet am {{ message.date_reminder | formatDate }}
            </h5>

            <button v-if="messagesUnconfirmed.length !== 0" @click="$refs.reminderConfirmationModal.show()" class="btn btn-cursor btn-neue mt-3 float-right">Erinnerung aussenden</button>
            <b-modal ref="reminderConfirmationModal" size="md" centered class="app-modals text-center" title="Erinnerung aussenden" hide-footer>
              <div>Wollen Sie an diese Personen eine Erinnerung aussenden?</div>
              <button @click="sendReminder()" class="btn btn-cursor btn-neue mt-4 mx-2">Ja</button>
              <button @click="$refs.reminderConfirmationModal.hide()" class="btn btn-cursor btn-neue mt-4 mx-2">Abbrechen</button>
            </b-modal>
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <b-modal ref="confirmationMsgModal" size="md" centered class="app-modals" hide-footer>
      <div slot="modal-title" class="w-100">
        Von: {{ modalTitle }}
      </div>
      <twemoji :content="modalMsg"/>
    </b-modal>

  </div>
</template>

<script>
import messageApi from '@/api/v1/messages';

export default {
  data() {
    return {
      user: this.$current_user,
      message: {},
      messagesConfirmed: {},
      messagesUnconfirmed: {},
      emptyConfirmedListAlert: '',
      emptyUnconfirmedListAlert: '',
      modalMsg: '',
      modalTitle: '',
    };
  },
  methods: {
    showModal(respondMsg) {
      this.modalMsg = respondMsg.message;
      this.modalTitle = respondMsg.confirmed_by.title;
      this.$refs.confirmationMsgModal.show();
      if (respondMsg.unread) {
        messageApi.openReply(respondMsg.itemid);
        // eslint-disable-next-line
        respondMsg.unread = false;
        this.$bus.refreshFeed();
        this.$bus.refreshUnreadedNo();
      }
    },
    sendReminder() {
      messageApi.sendReminder(this.$route.params.id).then(() => {
        this.$refs.reminderConfirmationModal.hide();
        messageApi.show((data) => {
          this.message = data.detailresponse;
        }, this.$route.params.id);
      });
    },
  },
  created() {
    messageApi.show((data) => {
      this.message = data.detailresponse;
      this.messagesConfirmed = data.detailresponse.answers;
      this.messagesUnconfirmed = data.detailresponse.unconfirmed_receivers;
      this.emptyConfirmedListAlert = 'Sie haben noch keine Bestätigungen erhalten.';
      this.emptyUnconfirmedListAlert = 'Alle Empfänger haben Ihre Nachricht bestätigt.';
    }, this.$route.params.id);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Messages/Show/Confirmations.vue